// extracted by extract-css-chunks-webpack-plugin
module.exports = {"dialog":"oaNvR","mobile":"dWux-","panelWidth":"-qzmH"};